!(function() {
  'use strict';
  /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ function t(
    t,
    e,
    s,
    i
  ) {
    var r,
      a = arguments.length,
      n = a < 3 ? e : null === i ? (i = Object.getOwnPropertyDescriptor(e, s)) : i;
    if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate) n = Reflect.decorate(t, e, s, i);
    else for (var l = t.length - 1; l >= 0; l--) (r = t[l]) && (n = (a < 3 ? r(n) : a > 3 ? r(e, s, n) : r(e, s)) || n);
    return a > 3 && n && Object.defineProperty(e, s, n), n;
  }
  function e(t, e) {
    if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata) return Reflect.metadata(t, e);
  }
  /**
   * @license
   * Copyright 2019 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ const s = window,
    i =
      s.ShadowRoot &&
      (void 0 === s.ShadyCSS || s.ShadyCSS.nativeShadow) &&
      'adoptedStyleSheets' in Document.prototype &&
      'replace' in CSSStyleSheet.prototype,
    r = Symbol(),
    a = new WeakMap();
  class n {
    constructor(t, e, s) {
      if (((this._$cssResult$ = !0), s !== r))
        throw Error('CSSResult is not constructable. Use `unsafeCSS` or `css` instead.');
      (this.cssText = t), (this.t = e);
    }
    get styleSheet() {
      let t = this.o;
      const e = this.t;
      if (i && void 0 === t) {
        const s = void 0 !== e && 1 === e.length;
        s && (t = a.get(e)),
          void 0 === t && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), s && a.set(e, t));
      }
      return t;
    }
    toString() {
      return this.cssText;
    }
  }
  const l = i
    ? (t) => t
    : (t) =>
        t instanceof CSSStyleSheet
          ? ((t) => {
              let e = '';
              for (const s of t.cssRules) e += s.cssText;
              return ((t) => new n('string' == typeof t ? t : t + '', void 0, r))(e);
            })(t)
          : t;
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ var o;
  const c = window,
    h = c.trustedTypes,
    d = h ? h.emptyScript : '',
    u = c.reactiveElementPolyfillSupport,
    p = {
      toAttribute(t, e) {
        switch (e) {
          case Boolean:
            t = t ? d : null;
            break;
          case Object:
          case Array:
            t = null == t ? t : JSON.stringify(t);
        }
        return t;
      },
      fromAttribute(t, e) {
        let s = t;
        switch (e) {
          case Boolean:
            s = null !== t;
            break;
          case Number:
            s = null === t ? null : Number(t);
            break;
          case Object:
          case Array:
            try {
              s = JSON.parse(t);
            } catch (t) {
              s = null;
            }
        }
        return s;
      }
    },
    g = (t, e) => e !== t && (e == e || t == t),
    v = { attribute: !0, type: String, converter: p, reflect: !1, hasChanged: g };
  class m extends HTMLElement {
    constructor() {
      super(),
        (this._$Ei = new Map()),
        (this.isUpdatePending = !1),
        (this.hasUpdated = !1),
        (this._$El = null),
        this.u();
    }
    static addInitializer(t) {
      var e;
      this.finalize(), (null !== (e = this.h) && void 0 !== e ? e : (this.h = [])).push(t);
    }
    static get observedAttributes() {
      this.finalize();
      const t = [];
      return (
        this.elementProperties.forEach((e, s) => {
          const i = this._$Ep(s, e);
          void 0 !== i && (this._$Ev.set(i, s), t.push(i));
        }),
        t
      );
    }
    static createProperty(t, e = v) {
      if (
        (e.state && (e.attribute = !1),
        this.finalize(),
        this.elementProperties.set(t, e),
        !e.noAccessor && !this.prototype.hasOwnProperty(t))
      ) {
        const s = 'symbol' == typeof t ? Symbol() : '__' + t,
          i = this.getPropertyDescriptor(t, s, e);
        void 0 !== i && Object.defineProperty(this.prototype, t, i);
      }
    }
    static getPropertyDescriptor(t, e, s) {
      return {
        get() {
          return this[e];
        },
        set(i) {
          const r = this[t];
          (this[e] = i), this.requestUpdate(t, r, s);
        },
        configurable: !0,
        enumerable: !0
      };
    }
    static getPropertyOptions(t) {
      return this.elementProperties.get(t) || v;
    }
    static finalize() {
      if (this.hasOwnProperty('finalized')) return !1;
      this.finalized = !0;
      const t = Object.getPrototypeOf(this);
      if (
        (t.finalize(),
        void 0 !== t.h && (this.h = [...t.h]),
        (this.elementProperties = new Map(t.elementProperties)),
        (this._$Ev = new Map()),
        this.hasOwnProperty('properties'))
      ) {
        const t = this.properties,
          e = [...Object.getOwnPropertyNames(t), ...Object.getOwnPropertySymbols(t)];
        for (const s of e) this.createProperty(s, t[s]);
      }
      return (this.elementStyles = this.finalizeStyles(this.styles)), !0;
    }
    static finalizeStyles(t) {
      const e = [];
      if (Array.isArray(t)) {
        const s = new Set(t.flat(1 / 0).reverse());
        for (const t of s) e.unshift(l(t));
      } else void 0 !== t && e.push(l(t));
      return e;
    }
    static _$Ep(t, e) {
      const s = e.attribute;
      return !1 === s ? void 0 : 'string' == typeof s ? s : 'string' == typeof t ? t.toLowerCase() : void 0;
    }
    u() {
      var t;
      (this._$E_ = new Promise((t) => (this.enableUpdating = t))),
        (this._$AL = new Map()),
        this._$Eg(),
        this.requestUpdate(),
        null === (t = this.constructor.h) || void 0 === t || t.forEach((t) => t(this));
    }
    addController(t) {
      var e, s;
      (null !== (e = this._$ES) && void 0 !== e ? e : (this._$ES = [])).push(t),
        void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
      var e;
      null === (e = this._$ES) || void 0 === e || e.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
      this.constructor.elementProperties.forEach((t, e) => {
        this.hasOwnProperty(e) && (this._$Ei.set(e, this[e]), delete this[e]);
      });
    }
    createRenderRoot() {
      var t;
      const e =
        null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
      return (
        ((t, e) => {
          i
            ? (t.adoptedStyleSheets = e.map((t) => (t instanceof CSSStyleSheet ? t : t.styleSheet)))
            : e.forEach((e) => {
                const i = document.createElement('style'),
                  r = s.litNonce;
                void 0 !== r && i.setAttribute('nonce', r), (i.textContent = e.cssText), t.appendChild(i);
              });
        })(e, this.constructor.elementStyles),
        e
      );
    }
    connectedCallback() {
      var t;
      void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()),
        this.enableUpdating(!0),
        null === (t = this._$ES) ||
          void 0 === t ||
          t.forEach((t) => {
            var e;
            return null === (e = t.hostConnected) || void 0 === e ? void 0 : e.call(t);
          });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
      var t;
      null === (t = this._$ES) ||
        void 0 === t ||
        t.forEach((t) => {
          var e;
          return null === (e = t.hostDisconnected) || void 0 === e ? void 0 : e.call(t);
        });
    }
    attributeChangedCallback(t, e, s) {
      this._$AK(t, s);
    }
    _$EO(t, e, s = v) {
      var i;
      const r = this.constructor._$Ep(t, s);
      if (void 0 !== r && !0 === s.reflect) {
        const a = (void 0 !== (null === (i = s.converter) || void 0 === i ? void 0 : i.toAttribute)
          ? s.converter
          : p
        ).toAttribute(e, s.type);
        (this._$El = t), null == a ? this.removeAttribute(r) : this.setAttribute(r, a), (this._$El = null);
      }
    }
    _$AK(t, e) {
      var s;
      const i = this.constructor,
        r = i._$Ev.get(t);
      if (void 0 !== r && this._$El !== r) {
        const t = i.getPropertyOptions(r),
          a =
            'function' == typeof t.converter
              ? { fromAttribute: t.converter }
              : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute)
              ? t.converter
              : p;
        (this._$El = r), (this[r] = a.fromAttribute(e, t.type)), (this._$El = null);
      }
    }
    requestUpdate(t, e, s) {
      let i = !0;
      void 0 !== t &&
        (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || g)(this[t], e)
          ? (this._$AL.has(t) || this._$AL.set(t, e),
            !0 === s.reflect &&
              this._$El !== t &&
              (void 0 === this._$EC && (this._$EC = new Map()), this._$EC.set(t, s)))
          : (i = !1)),
        !this.isUpdatePending && i && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
      this.isUpdatePending = !0;
      try {
        await this._$E_;
      } catch (t) {
        Promise.reject(t);
      }
      const t = this.scheduleUpdate();
      return null != t && (await t), !this.isUpdatePending;
    }
    scheduleUpdate() {
      return this.performUpdate();
    }
    performUpdate() {
      var t;
      if (!this.isUpdatePending) return;
      this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, e) => (this[e] = t)), (this._$Ei = void 0));
      let e = !1;
      const s = this._$AL;
      try {
        (e = this.shouldUpdate(s)),
          e
            ? (this.willUpdate(s),
              null === (t = this._$ES) ||
                void 0 === t ||
                t.forEach((t) => {
                  var e;
                  return null === (e = t.hostUpdate) || void 0 === e ? void 0 : e.call(t);
                }),
              this.update(s))
            : this._$Ek();
      } catch (t) {
        throw ((e = !1), this._$Ek(), t);
      }
      e && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
      var e;
      null === (e = this._$ES) ||
        void 0 === e ||
        e.forEach((t) => {
          var e;
          return null === (e = t.hostUpdated) || void 0 === e ? void 0 : e.call(t);
        }),
        this.hasUpdated || ((this.hasUpdated = !0), this.firstUpdated(t)),
        this.updated(t);
    }
    _$Ek() {
      (this._$AL = new Map()), (this.isUpdatePending = !1);
    }
    get updateComplete() {
      return this.getUpdateComplete();
    }
    getUpdateComplete() {
      return this._$E_;
    }
    shouldUpdate(t) {
      return !0;
    }
    update(t) {
      void 0 !== this._$EC && (this._$EC.forEach((t, e) => this._$EO(e, this[e], t)), (this._$EC = void 0)),
        this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
  }
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
  var f;
  (m.finalized = !0),
    (m.elementProperties = new Map()),
    (m.elementStyles = []),
    (m.shadowRootOptions = { mode: 'open' }),
    null == u || u({ ReactiveElement: m }),
    (null !== (o = c.reactiveElementVersions) && void 0 !== o ? o : (c.reactiveElementVersions = [])).push('1.6.1');
  const y = window,
    $ = y.trustedTypes,
    A = $ ? $.createPolicy('lit-html', { createHTML: (t) => t }) : void 0,
    S = `lit$${(Math.random() + '').slice(9)}$`,
    b = '?' + S,
    _ = `<${b}>`,
    k = document,
    w = () => k.createComment(''),
    E = (t) => null === t || ('object' != typeof t && 'function' != typeof t),
    C = Array.isArray,
    x = '[ \t\n\f\r]',
    O = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,
    T = /-->/g,
    U = />/g,
    P = RegExp(`>|${x}(?:([^\\s"'>=/]+)(${x}*=${x}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, 'g'),
    H = /'/g,
    I = /"/g,
    N = /^(?:script|style|textarea|title)$/i,
    R = ((t) => (e, ...s) => ({ _$litType$: t, strings: e, values: s }))(1),
    j = Symbol.for('lit-noChange'),
    z = Symbol.for('lit-nothing'),
    W = new WeakMap(),
    F = k.createTreeWalker(k, 129, null, !1),
    L = (t, e) => {
      const s = t.length - 1,
        i = [];
      let r,
        a = 2 === e ? '<svg>' : '',
        n = O;
      for (let e = 0; e < s; e++) {
        const s = t[e];
        let l,
          o,
          c = -1,
          h = 0;
        for (; h < s.length && ((n.lastIndex = h), (o = n.exec(s)), null !== o); )
          (h = n.lastIndex),
            n === O
              ? '!--' === o[1]
                ? (n = T)
                : void 0 !== o[1]
                ? (n = U)
                : void 0 !== o[2]
                ? (N.test(o[2]) && (r = RegExp('</' + o[2], 'g')), (n = P))
                : void 0 !== o[3] && (n = P)
              : n === P
              ? '>' === o[0]
                ? ((n = null != r ? r : O), (c = -1))
                : void 0 === o[1]
                ? (c = -2)
                : ((c = n.lastIndex - o[2].length), (l = o[1]), (n = void 0 === o[3] ? P : '"' === o[3] ? I : H))
              : n === I || n === H
              ? (n = P)
              : n === T || n === U
              ? (n = O)
              : ((n = P), (r = void 0));
        const d = n === P && t[e + 1].startsWith('/>') ? ' ' : '';
        a +=
          n === O
            ? s + _
            : c >= 0
            ? (i.push(l), s.slice(0, c) + '$lit$' + s.slice(c) + S + d)
            : s + S + (-2 === c ? (i.push(void 0), e) : d);
      }
      const l = a + (t[s] || '<?>') + (2 === e ? '</svg>' : '');
      if (!Array.isArray(t) || !t.hasOwnProperty('raw')) throw Error('invalid template strings array');
      return [void 0 !== A ? A.createHTML(l) : l, i];
    };
  class M {
    constructor({ strings: t, _$litType$: e }, s) {
      let i;
      this.parts = [];
      let r = 0,
        a = 0;
      const n = t.length - 1,
        l = this.parts,
        [o, c] = L(t, e);
      if (((this.el = M.createElement(o, s)), (F.currentNode = this.el.content), 2 === e)) {
        const t = this.el.content,
          e = t.firstChild;
        e.remove(), t.append(...e.childNodes);
      }
      for (; null !== (i = F.nextNode()) && l.length < n; ) {
        if (1 === i.nodeType) {
          if (i.hasAttributes()) {
            const t = [];
            for (const e of i.getAttributeNames())
              if (e.endsWith('$lit$') || e.startsWith(S)) {
                const s = c[a++];
                if ((t.push(e), void 0 !== s)) {
                  const t = i.getAttribute(s.toLowerCase() + '$lit$').split(S),
                    e = /([.?@])?(.*)/.exec(s);
                  l.push({
                    type: 1,
                    index: r,
                    name: e[2],
                    strings: t,
                    ctor: '.' === e[1] ? K : '?' === e[1] ? Z : '@' === e[1] ? G : D
                  });
                } else l.push({ type: 6, index: r });
              }
            for (const e of t) i.removeAttribute(e);
          }
          if (N.test(i.tagName)) {
            const t = i.textContent.split(S),
              e = t.length - 1;
            if (e > 0) {
              i.textContent = $ ? $.emptyScript : '';
              for (let s = 0; s < e; s++) i.append(t[s], w()), F.nextNode(), l.push({ type: 2, index: ++r });
              i.append(t[e], w());
            }
          }
        } else if (8 === i.nodeType)
          if (i.data === b) l.push({ type: 2, index: r });
          else {
            let t = -1;
            for (; -1 !== (t = i.data.indexOf(S, t + 1)); ) l.push({ type: 7, index: r }), (t += S.length - 1);
          }
        r++;
      }
    }
    static createElement(t, e) {
      const s = k.createElement('template');
      return (s.innerHTML = t), s;
    }
  }
  function V(t, e, s = t, i) {
    var r, a, n, l;
    if (e === j) return e;
    let o = void 0 !== i ? (null === (r = s._$Co) || void 0 === r ? void 0 : r[i]) : s._$Cl;
    const c = E(e) ? void 0 : e._$litDirective$;
    return (
      (null == o ? void 0 : o.constructor) !== c &&
        (null === (a = null == o ? void 0 : o._$AO) || void 0 === a || a.call(o, !1),
        void 0 === c ? (o = void 0) : ((o = new c(t)), o._$AT(t, s, i)),
        void 0 !== i ? ((null !== (n = (l = s)._$Co) && void 0 !== n ? n : (l._$Co = []))[i] = o) : (s._$Cl = o)),
      void 0 !== o && (e = V(t, o._$AS(t, e.values), o, i)),
      e
    );
  }
  class B {
    constructor(t, e) {
      (this._$AV = []), (this._$AN = void 0), (this._$AD = t), (this._$AM = e);
    }
    get parentNode() {
      return this._$AM.parentNode;
    }
    get _$AU() {
      return this._$AM._$AU;
    }
    u(t) {
      var e;
      const {
          el: { content: s },
          parts: i
        } = this._$AD,
        r = (null !== (e = null == t ? void 0 : t.creationScope) && void 0 !== e ? e : k).importNode(s, !0);
      F.currentNode = r;
      let a = F.nextNode(),
        n = 0,
        l = 0,
        o = i[0];
      for (; void 0 !== o; ) {
        if (n === o.index) {
          let e;
          2 === o.type
            ? (e = new q(a, a.nextSibling, this, t))
            : 1 === o.type
            ? (e = new o.ctor(a, o.name, o.strings, this, t))
            : 6 === o.type && (e = new Q(a, this, t)),
            this._$AV.push(e),
            (o = i[++l]);
        }
        n !== (null == o ? void 0 : o.index) && ((a = F.nextNode()), n++);
      }
      return (F.currentNode = k), r;
    }
    v(t) {
      let e = 0;
      for (const s of this._$AV)
        void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, e), (e += s.strings.length - 2)) : s._$AI(t[e])), e++;
    }
  }
  class q {
    constructor(t, e, s, i) {
      var r;
      (this.type = 2),
        (this._$AH = z),
        (this._$AN = void 0),
        (this._$AA = t),
        (this._$AB = e),
        (this._$AM = s),
        (this.options = i),
        (this._$Cp = null === (r = null == i ? void 0 : i.isConnected) || void 0 === r || r);
    }
    get _$AU() {
      var t, e;
      return null !== (e = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== e ? e : this._$Cp;
    }
    get parentNode() {
      let t = this._$AA.parentNode;
      const e = this._$AM;
      return void 0 !== e && 11 === (null == t ? void 0 : t.nodeType) && (t = e.parentNode), t;
    }
    get startNode() {
      return this._$AA;
    }
    get endNode() {
      return this._$AB;
    }
    _$AI(t, e = this) {
      (t = V(this, t, e)),
        E(t)
          ? t === z || null == t || '' === t
            ? (this._$AH !== z && this._$AR(), (this._$AH = z))
            : t !== this._$AH && t !== j && this._(t)
          : void 0 !== t._$litType$
          ? this.g(t)
          : void 0 !== t.nodeType
          ? this.$(t)
          : ((t) => C(t) || 'function' == typeof (null == t ? void 0 : t[Symbol.iterator]))(t)
          ? this.T(t)
          : this._(t);
    }
    k(t) {
      return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
      this._$AH !== t && (this._$AR(), (this._$AH = this.k(t)));
    }
    _(t) {
      this._$AH !== z && E(this._$AH) ? (this._$AA.nextSibling.data = t) : this.$(k.createTextNode(t)), (this._$AH = t);
    }
    g(t) {
      var e;
      const { values: s, _$litType$: i } = t,
        r = 'number' == typeof i ? this._$AC(t) : (void 0 === i.el && (i.el = M.createElement(i.h, this.options)), i);
      if ((null === (e = this._$AH) || void 0 === e ? void 0 : e._$AD) === r) this._$AH.v(s);
      else {
        const t = new B(r, this),
          e = t.u(this.options);
        t.v(s), this.$(e), (this._$AH = t);
      }
    }
    _$AC(t) {
      let e = W.get(t.strings);
      return void 0 === e && W.set(t.strings, (e = new M(t))), e;
    }
    T(t) {
      C(this._$AH) || ((this._$AH = []), this._$AR());
      const e = this._$AH;
      let s,
        i = 0;
      for (const r of t)
        i === e.length ? e.push((s = new q(this.k(w()), this.k(w()), this, this.options))) : (s = e[i]), s._$AI(r), i++;
      i < e.length && (this._$AR(s && s._$AB.nextSibling, i), (e.length = i));
    }
    _$AR(t = this._$AA.nextSibling, e) {
      var s;
      for (null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, e); t && t !== this._$AB; ) {
        const e = t.nextSibling;
        t.remove(), (t = e);
      }
    }
    setConnected(t) {
      var e;
      void 0 === this._$AM && ((this._$Cp = t), null === (e = this._$AP) || void 0 === e || e.call(this, t));
    }
  }
  class D {
    constructor(t, e, s, i, r) {
      (this.type = 1),
        (this._$AH = z),
        (this._$AN = void 0),
        (this.element = t),
        (this.name = e),
        (this._$AM = i),
        (this.options = r),
        s.length > 2 || '' !== s[0] || '' !== s[1]
          ? ((this._$AH = Array(s.length - 1).fill(new String())), (this.strings = s))
          : (this._$AH = z);
    }
    get tagName() {
      return this.element.tagName;
    }
    get _$AU() {
      return this._$AM._$AU;
    }
    _$AI(t, e = this, s, i) {
      const r = this.strings;
      let a = !1;
      if (void 0 === r) (t = V(this, t, e, 0)), (a = !E(t) || (t !== this._$AH && t !== j)), a && (this._$AH = t);
      else {
        const i = t;
        let n, l;
        for (t = r[0], n = 0; n < r.length - 1; n++)
          (l = V(this, i[s + n], e, n)),
            l === j && (l = this._$AH[n]),
            a || (a = !E(l) || l !== this._$AH[n]),
            l === z ? (t = z) : t !== z && (t += (null != l ? l : '') + r[n + 1]),
            (this._$AH[n] = l);
      }
      a && !i && this.j(t);
    }
    j(t) {
      t === z ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : '');
    }
  }
  class K extends D {
    constructor() {
      super(...arguments), (this.type = 3);
    }
    j(t) {
      this.element[this.name] = t === z ? void 0 : t;
    }
  }
  const J = $ ? $.emptyScript : '';
  class Z extends D {
    constructor() {
      super(...arguments), (this.type = 4);
    }
    j(t) {
      t && t !== z ? this.element.setAttribute(this.name, J) : this.element.removeAttribute(this.name);
    }
  }
  class G extends D {
    constructor(t, e, s, i, r) {
      super(t, e, s, i, r), (this.type = 5);
    }
    _$AI(t, e = this) {
      var s;
      if ((t = null !== (s = V(this, t, e, 0)) && void 0 !== s ? s : z) === j) return;
      const i = this._$AH,
        r = (t === z && i !== z) || t.capture !== i.capture || t.once !== i.once || t.passive !== i.passive,
        a = t !== z && (i === z || r);
      r && this.element.removeEventListener(this.name, this, i),
        a && this.element.addEventListener(this.name, this, t),
        (this._$AH = t);
    }
    handleEvent(t) {
      var e, s;
      'function' == typeof this._$AH
        ? this._$AH.call(
            null !== (s = null === (e = this.options) || void 0 === e ? void 0 : e.host) && void 0 !== s
              ? s
              : this.element,
            t
          )
        : this._$AH.handleEvent(t);
    }
  }
  class Q {
    constructor(t, e, s) {
      (this.element = t), (this.type = 6), (this._$AN = void 0), (this._$AM = e), (this.options = s);
    }
    get _$AU() {
      return this._$AM._$AU;
    }
    _$AI(t) {
      V(this, t);
    }
  }
  const X = y.litHtmlPolyfillSupport;
  null == X || X(M, q), (null !== (f = y.litHtmlVersions) && void 0 !== f ? f : (y.litHtmlVersions = [])).push('2.7.4');
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
  var Y, tt;
  class et extends m {
    constructor() {
      super(...arguments), (this.renderOptions = { host: this }), (this._$Do = void 0);
    }
    createRenderRoot() {
      var t, e;
      const s = super.createRenderRoot();
      return (
        (null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t) || (e.renderBefore = s.firstChild), s
      );
    }
    update(t) {
      const e = this.render();
      this.hasUpdated || (this.renderOptions.isConnected = this.isConnected),
        super.update(t),
        (this._$Do = ((t, e, s) => {
          var i, r;
          const a = null !== (i = null == s ? void 0 : s.renderBefore) && void 0 !== i ? i : e;
          let n = a._$litPart$;
          if (void 0 === n) {
            const t = null !== (r = null == s ? void 0 : s.renderBefore) && void 0 !== r ? r : null;
            a._$litPart$ = n = new q(e.insertBefore(w(), t), t, void 0, null != s ? s : {});
          }
          return n._$AI(t), n;
        })(e, this.renderRoot, this.renderOptions));
    }
    connectedCallback() {
      var t;
      super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
      var t;
      super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
      return j;
    }
  }
  (et.finalized = !0),
    (et._$litElement$ = !0),
    null === (Y = globalThis.litElementHydrateSupport) || void 0 === Y || Y.call(globalThis, { LitElement: et });
  const st = globalThis.litElementPolyfillSupport;
  null == st || st({ LitElement: et }),
    (null !== (tt = globalThis.litElementVersions) && void 0 !== tt ? tt : (globalThis.litElementVersions = [])).push(
      '3.3.2'
    );
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
  const it = (t, e) =>
    'method' === e.kind && e.descriptor && !('value' in e.descriptor)
      ? {
          ...e,
          finisher(s) {
            s.createProperty(e.key, t);
          }
        }
      : {
          kind: 'field',
          key: Symbol(),
          placement: 'own',
          descriptor: {},
          originalKey: e.key,
          initializer() {
            'function' == typeof e.initializer && (this[e.key] = e.initializer.call(this));
          },
          finisher(s) {
            s.createProperty(e.key, t);
          }
        };
  function rt(t) {
    return (e, s) =>
      void 0 !== s
        ? ((t, e, s) => {
            e.constructor.createProperty(s, t);
          })(t, e, s)
        : it(t, e);
    /**
     * @license
     * Copyright 2017 Google LLC
     * SPDX-License-Identifier: BSD-3-Clause
     */
  }
  function at(t) {
    return rt({ ...t, state: !0 });
  }
  /**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ var nt;
  null === (nt = window.HTMLSlotElement) || void 0 === nt || nt.prototype.assignedElements;
  var lt = {
    ar: {
      clear: 'محو',
      selectAll: 'حدد الكل',
      search: 'البحث',
      switchWorkspace: 'تبديل مساحة العمل',
      language: 'لغة',
      manageAccount: 'إدارة الحساب',
      signOut: 'خروج'
    },
    cs: {
      clear: 'Jasn',
      selectAll: 'Vybrat vše',
      search: 'Vyhledávání',
      switchWorkspace: 'přepnout pracovní prostor',
      language: 'Jazyk',
      manageAccount: 'spravovat účet',
      signOut: 'odhlásit se'
    },
    en: {
      clear: 'Clear',
      selectAll: 'Select all',
      search: 'Search',
      switchWorkspace: 'Switch workspace',
      language: 'Language',
      manageAccount: 'Manage account',
      signOut: 'Sign out'
    },
    es: {
      clear: 'Borrar',
      selectAll: 'Seleccionar todo',
      search: 'Buscar',
      switchWorkspace: 'Cambiar entorno de trabajo',
      language: 'Idioma',
      manageAccount: 'Gestionar cuenta',
      signOut: 'Salir'
    },
    da: {
      clear: 'Tydelig',
      selectAll: 'Vælg alle',
      search: 'Søg',
      switchWorkspace: 'Skifte arbejdsområde',
      language: 'Sprog',
      manageAccount: 'Administrer konto',
      signOut: 'Log ud'
    },
    de: {
      clear: 'Entfernen',
      selectAll: 'Alles auswählen',
      search: 'Suchen',
      switchWorkspace: 'Switch workspace',
      language: 'Language',
      manageAccount: 'Konto verwalten',
      signOut: 'Abmelden'
    },
    el: {
      clear: 'σαφής',
      selectAll: 'Επιλογή Όλων',
      search: 'Αναζήτηση',
      switchWorkspace: 'Arbeitsbereich wechseln',
      language: 'Sprache',
      manageAccount: 'Konto verwalten',
      signOut: 'Sign out'
    },
    fi: {
      clear: 'Tyhjennä',
      selectAll: 'Valitse kaikki',
      search: 'Hae',
      switchWorkspace: 'Vaihda työtilaa',
      language: 'Kieli',
      manageAccount: 'Hallitse tiliä',
      signOut: 'Kirjaudu ulos'
    },
    fr: {
      clear: 'Effacer',
      selectAll: 'Tout sélectionner',
      search: 'Chercher',
      switchWorkspace: 'Vaihtaa työtilaa',
      language: 'Kieli',
      manageAccount: 'Hallitse tiliä',
      signOut: 'Kirjaudu ulos'
    },
    hu: {
      clear: 'Világos',
      selectAll: 'Mindet kiválaszt',
      search: 'Keresés',
      switchWorkspace: 'Munkaterület váltása',
      language: 'Nyelv',
      manageAccount: 'Fiók kezelése',
      signOut: 'Kijelentkezés'
    },
    hy: {
      clear: 'ջնջել',
      selectAll: 'Ընտրել բոլորը',
      search: 'Որոնում',
      switchWorkspace: 'Փոխել աշխատանքային տարածքը',
      language: 'Լեզու',
      manageAccount: 'Կառավարեք հաշիվը',
      signOut: 'Դուրս գալ'
    },
    it: {
      clear: 'Cancella',
      selectAll: 'Seleziona tutto',
      search: 'Ricerca',
      switchWorkspace: 'Cambia area di lavoro',
      language: 'Lingua',
      manageAccount: 'Gestisci profilo',
      signOut: 'Disconnessione'
    },
    ja: {
      clear: 'クリア',
      selectAll: 'すべて選択',
      search: '探す',
      switchWorkspace: 'ワークスペースを切り替える',
      language: '言語',
      manageAccount: 'アカウントの管理',
      signOut: 'サインアウト'
    },
    ka: {
      clear: 'წაშლა',
      selectAll: 'Მონიშნე ყველა',
      search: 'ძებნა',
      switchWorkspace: 'სამუშაო სივრცის შეცვლა',
      language: 'Ენა',
      manageAccount: 'Ანგარიშის მართვა',
      signOut: 'Სისტემიდან გამოსვლა'
    },
    ko: {
      clear: '분명',
      selectAll: '모두 선택',
      search: '검색',
      switchWorkspace: '작업공간 전환',
      language: '언어',
      manageAccount: '계정 관리',
      signOut: '로그아웃'
    },
    nb: {
      clear: 'Tøm',
      selectAll: 'Velg alle',
      search: 'Søk',
      switchWorkspace: 'Bytt arbeidsområde',
      language: 'Språk',
      manageAccount: 'Administrer konto',
      signOut: 'Logg ut'
    },
    nl: {
      clear: 'Verwijder',
      selectAll: 'Selecteer alles',
      search: 'Zoeken',
      switchWorkspace: 'Wissel van werkruimte',
      language: 'Taal',
      manageAccount: 'Beheer account',
      signOut: 'Afmelden'
    },
    pl: {
      clear: 'Jasne',
      selectAll: 'Zaznacz wszystko',
      search: 'Szukaj',
      switchWorkspace: 'Zmień obszar roboczy',
      language: 'Język',
      manageAccount: 'Zarządzać kontem',
      signOut: 'Wyloguj się'
    },
    pt: {
      clear: 'Claro',
      selectAll: 'Selecionar tudo',
      search: 'Pesquisa',
      switchWorkspace: 'Alternar espaço de trabalho',
      language: 'Linguagem',
      manageAccount: 'Gerenciar conta',
      signOut: 'Sair'
    },
    ro: {
      clear: 'Clar',
      selectAll: 'Selectează tot',
      search: 'Căutare',
      switchWorkspace: 'Schimbați spațiul de lucru',
      language: 'Limba',
      manageAccount: 'Gestionați contul',
      signOut: 'Sign out'
    },
    ru: {
      clear: 'ясненько',
      selectAll: 'Выбрать все',
      search: 'Поиск',
      switchWorkspace: 'Переключить рабочее пространство',
      language: 'Язык',
      manageAccount: 'Управлять счетом',
      signOut: 'выход'
    },
    sk: {
      clear: 'Jasný',
      selectAll: 'Vybrať všetko',
      search: 'Vyhľadávanie',
      switchWorkspace: 'Prepnúť pracovný priestor',
      language: 'Jazyk',
      manageAccount: 'Spravovať účet',
      signOut: 'Odhlásiť Sa'
    },
    sv: {
      clear: 'Klar',
      selectAll: 'Välj alla',
      search: 'Sök',
      switchWorkspace: 'Byt arbetsyta',
      language: 'Språk',
      manageAccount: 'Hantera konto',
      signOut: 'Logga ut'
    },
    tr: {
      clear: 'Berrak',
      selectAll: 'Hepsini seç',
      search: 'Arama',
      switchWorkspace: 'Çalışma alanını değiştir',
      language: 'Dil',
      manageAccount: 'Hesabı yönet',
      signOut: 'Oturumu Kapat'
    },
    uk: {
      clear: 'Ясно',
      selectAll: 'Вибрати все',
      search: 'Пошук',
      switchWorkspace: 'Перемикання робочого простору',
      language: 'Мова',
      manageAccount: 'Керувати обліковим записом',
      signOut: 'Вийти з аккаунта'
    },
    zh: {
      clear: '清楚',
      selectAll: '全选',
      search: '搜索',
      switchWorkspace: '切换工作空间',
      language: '语言',
      manageAccount: '管理帐户',
      signOut: '登出'
    }
  };
  class ot extends et {
    constructor() {
      super(...arguments),
        (this.selectedTabState = -1),
        (this.previousTabState = -1),
        (this.language = 'en'),
        (this.filtersState = []),
        (this.selectedFilterItemsState = []),
        (this.searchState = []),
        (this.validationState = !1),
        (this.disabledState = !1);
    }
    set disabled(t) {
      (this.disabledState = 'true' === t), this.requestUpdate();
    }
    set filters(t) {
      (this.filtersState = JSON.parse(t)), this.requestUpdate();
    }
    set selectedFilterItems(t) {
      (this.selectedFilterItemsState = JSON.parse(t)), this.requestUpdate();
    }
    set validation(t) {
      (this.validationState = 'true' === t), this.requestUpdate();
    }
    set selectedTab(t) {
      (this.selectedTabState = Number(t)), (this.previousTabState = Number(t)), this.requestUpdate();
    }
    set error(t) {
      var e;
      if ('string' == typeof t && t.length > 0) {
        this.errorState = t;
        const s = null === (e = this.shadowRoot) || void 0 === e ? void 0 : e.querySelector('input');
        s && s.setCustomValidity(this.errorState);
      } else this.errorState = void 0;
      this.requestUpdate();
    }
    firstUpdated() {
      this.requestUpdate();
    }
    areAllSelected(t) {
      return !this.filtersState[t].items.map((t) => t.id).some((t) => !this.selectedFilterItemsState.includes(t));
    }
    someAreSelected(t) {
      return this.filtersState[t].items.map((t) => t.id).some((t) => this.selectedFilterItemsState.includes(t));
    }
    selectAllFilter(t) {
      const e = this.areAllSelected(t),
        s = this.filtersState[t].items.map((t) => t.id);
      (this.selectedFilterItemsState = this.selectedFilterItemsState.filter((t) => !s.includes(t))),
        e || (this.selectedFilterItemsState = this.selectedFilterItemsState.concat(s)),
        this.triggerChange();
    }
    searchByName(t, e) {
      (this.searchState[t] = e), this.requestUpdate();
    }
    selectFilter(t) {
      this.selectedFilterItemsState.includes(t)
        ? (this.selectedFilterItemsState = this.selectedFilterItemsState.filter((e) => e !== t))
        : this.selectedFilterItemsState.push(t),
        this.requestUpdate(),
        this.triggerChange();
    }
    triggerChange() {
      const t = new CustomEvent('filtersChanged', {
        bubbles: !0,
        composed: !0,
        detail: { value: this.selectedFilterItemsState, validated: this.validated }
      });
      this.dispatchEvent(t);
    }
    get validated() {
      let t = !0;
      return (
        this.filtersState.forEach((e) => {
          t = t && e.items.map((t) => t.id).some((t) => this.selectedFilterItemsState.includes(t));
        }),
        t
      );
    }
    selectedItemsInFilter(t) {
      let e = 0;
      return (
        this.filtersState[t].items
          .map((t) => t.id)
          .forEach((t) => {
            e = this.selectedFilterItemsState.includes(t) ? e + 1 : e;
          }),
        e
      );
    }
    handleChangeTabs(t) {
      let e = t;
      this.previousTabState === t ? ((this.selectedTabState = -2), (e = -1)) : (this.selectedTabState = t),
        (this.previousTabState = -1 === e ? -1 : t),
        setTimeout(() => {
          (this.selectedTabState = e), this.requestUpdate();
        }, 50);
    }
    render() {
      return R`
      ${R`
  <link
    rel="stylesheet"
    href="https://storybook.talentech.io/css/${
      (null === (t = document.querySelector('body')) || void 0 === t
      ? void 0
      : t.classList.contains('visma'))
        ? 'themes/visma/bundle.css'
        : '0.4.97/bundle.min.css'
    }"
  />
  <!-- <link rel="stylesheet" href="https://storybook.talentech.io/css/themes/visma/bundle.css" /> -->
  <link
    rel="stylesheet"
    href="https://static.talentech.io/fonts/Telegraf/talentech-telegraf.css"
  />
  <link
    rel="stylesheet"
    href="https://static.talentech.io/googlefonts/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap"
  />
  <link rel="stylesheet" href="https://static.talentech.io/iconfont/TIconography/style.css" />
`}
      <div class="filters-container">
        <div class="filters-list">
          ${
            this.disabledState
              ? R`
            <ul>
              ${this.filtersState.map((t, e) =>
                this.someAreSelected(e)
                  ? R`
                    <li>
                      <div class="pb-1">${t.name}</div>
                      ${t.items
                        .filter((t) => this.selectedFilterItemsState.includes(t.id))
                        .map(
                          (e, s) => R`
                            <span class="filter-item"
                              >${e.name}${
                            s === t.items.filter((t) => this.selectedFilterItemsState.includes(t.id)).length - 1
                              ? ''
                              : ','
                          }</span
                            >
                          `
                        )}
                    </li>
                  `
                  : ''
              )}
            </ul>
        </div>
        `
              : R`
                <tabs-talentech
                  selected="${this.selectedTabState}"
                  @update="${(t) => this.handleChangeTabs(t.detail.value)}"
                >
                  ${this.filtersState.map(
                    (t, e) => R`
                      <div slot="${'tab-title-' + e}">
                        <div class="tab-header-container">
                          <span>${t.name}</span>
                          <badge-talentech
                            color="${
                              this.validationState && 0 === this.selectedItemsInFilter(e) ? 'danger' : 'secondary'
                            }"
                            >${this.selectedItemsInFilter(e)}</badge-talentech
                          >
                        </div>
                      </div>
                      <div
                        slot="${'tab-content-' + e}"
                        style="padding:20px; background-color: white"
                      >
                        <div class="filters-tab-container">
                          ${
                            t.items.length > 10
                              ? R`
                                <div class="search-container">
                                  <input-talentech
                                    icon="light-01_interface_essentials-search-search"
                                    placeholder="${lt[this.language].search}"
                                    @keyup=${(t) => (t.isTrusted ? '' : this.searchByName(e, t.detail.value))}
                                  ></input-talentech>
                                </div>
                              `
                              : ''
                          }
                          <div class="filters-check-box-container">
                            <div class="checkbox-container">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                aria-label="${lt[this.language].selectAll}"
                                .checked=${this.areAllSelected(e)}
                                @click=${() => this.selectAllFilter(e)}
                              />
                              <label class="form-check-label" for="flexCheckSmall">
                                ${lt[this.language].selectAll}
                              </label>
                            </div>
                            ${t.items
                              .filter((t) =>
                                t.name
                                  .toLocaleLowerCase()
                                  .includes(this.searchState[e] ? this.searchState[e].toLocaleLowerCase() : '')
                              )
                              .map(
                                (t) => R`
                                  <div class="checkbox-container">
                                    <input
                                      type="checkbox"
                                      value="${t.id}"
                                      class="form-check-input"
                                      aria-label="${t.name}"
                                      .checked=${this.selectedFilterItemsState.includes(Number(t.id))}
                                      @click=${() => this.selectFilter(t.id)}
                                    />
                                    <label class="form-check-label" for="flexCheckSmall">
                                      ${t.name}
                                    </label>
                                  </div>
                                `
                              )}
                          </div>
                        </div>
                      </div>
                    `
                  )}
                </tabs-talentech>
              `
          }
        </div>
        ${
          this.errorState
            ? R`
              <div class="invalid-feedback">
                ${this.errorState}
              </div>
            `
            : ''
        }
      </div>
    `;
      var t;
    }
  }
  (ot.styles = [
    ((t, ...e) => {
      const s =
        1 === t.length
          ? t[0]
          : e.reduce(
              (e, s, i) =>
                e +
                ((t) => {
                  if (!0 === t._$cssResult$) return t.cssText;
                  if ('number' == typeof t) return t;
                  throw Error(
                    "Value passed to 'css' function must be a 'css' function result: " +
                      t +
                      ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security."
                  );
                })(s) +
                t[i + 1],
              t[0]
            );
      return new n(s, t, r);
    })`
      :host {
        display: block;
      }
      .filters-container {
        background-color: white;
      }
      .tabs-container ul.nav.nav-tabs {
        background-color: white;
      }
      .form-check-label {
        margin-right: 16px;
      }
      .filters-tab-container .search-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-bottom: 24px;
        border-bottom: solid 1px var(--bs-gray-400);
        margin-bottom: 16px;
        gap: 16px;
      }
      .filters-tab-container .search-container input-talentech {
        flex-grow: 1;
      }
      .filters-check-box-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }
      .filters-check-box-container .checkbox-container {
        margin: 8px 0;
        display: flex;
        flex-direction: row;
      }
      .filters-check-box-container .checkbox-container:first-child {
        border-right: solid 1px var(--bs-gray-400);
        margin-right: 16px;
      }

      .tab-header-container {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
      }
      .invalid-feedback {
        display: block;
        padding-left: 8px;
      }

      .filters-list ul {
        padding-left: 0;
        margin: 0;
      }

      .filters-list li {
        border-bottom: solid 1px #d6d6dc;
        list-style: none;
        padding: 16px 12px;
      }

      .filters-list li:last-child {
        border-bottom: none;
      }

      .filter-item {
        color: #60606c;
      }
    `
  ]),
    t(
      [rt({ type: String }), e('design:type', String), e('design:paramtypes', [String])],
      ot.prototype,
      'disabled',
      null
    ),
    t(
      [rt({ type: String }), e('design:type', String), e('design:paramtypes', [String])],
      ot.prototype,
      'filters',
      null
    ),
    t(
      [rt({ type: String }), e('design:type', String), e('design:paramtypes', [String])],
      ot.prototype,
      'selectedFilterItems',
      null
    ),
    t(
      [rt({ type: String }), e('design:type', String), e('design:paramtypes', [String])],
      ot.prototype,
      'validation',
      null
    ),
    t(
      [rt({ type: String }), e('design:type', String), e('design:paramtypes', [String])],
      ot.prototype,
      'selectedTab',
      null
    ),
    t([at(), e('design:type', Object)], ot.prototype, 'selectedTabState', void 0),
    t([at(), e('design:type', Object)], ot.prototype, 'previousTabState', void 0),
    t([rt({ type: String }), e('design:type', Object)], ot.prototype, 'language', void 0),
    t([rt({ type: String }), e('design:type', String), e('design:paramtypes', [String])], ot.prototype, 'error', null),
    t([at(), e('design:type', String)], ot.prototype, 'errorState', void 0),
    t([at(), e('design:type', Array)], ot.prototype, 'filtersState', void 0),
    t([at(), e('design:type', Array)], ot.prototype, 'selectedFilterItemsState', void 0),
    t([at(), e('design:type', Array)], ot.prototype, 'searchState', void 0),
    t([at(), e('design:type', Object)], ot.prototype, 'validationState', void 0),
    t([at(), e('design:type', Object)], ot.prototype, 'disabledState', void 0),
    window.customElements.define('filters-talentech', ot);
})();
